
export const CHECK_STATE = ["待审批", "通过", "驳回"]

export const CHECK_TYPE = {
    1: "依次审批",
    2: "会签",
    3: "或签"
}
export const RECTIFICATION_STATE = ["未审批","审批通过","审批驳回"]